"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.appPropTypes = exports.initialState = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _types = require("../types");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  blocked: false,
  botProjectId: '',
  context: _constants.CONTEXT_CHATBOTS_API,
  conversationId: '',
  env: 'dev',
  error: null,
  inputValidation: null,
  product: '',
  scrolled: true,
  sessionId: (0, _v["default"])(),
  settings: {},
  typing: false,
  variables: {},
  debug: false
};
exports.initialState = initialState;
var appPropTypes = {
  blocked: _propTypes["default"].bool,
  botProjectId: _propTypes["default"].string,
  context: _propTypes["default"].string,
  conversationId: _propTypes["default"].string,
  debug: _propTypes["default"].bool,
  env: _propTypes["default"].string,
  error: _propTypes["default"].object,
  inputValidation: _propTypes["default"].object,
  product: _propTypes["default"].string,
  scrolled: _propTypes["default"].bool,
  sessionId: _propTypes["default"].string,
  settings: _propTypes["default"].object,
  typing: _propTypes["default"].bool,
  variables: _propTypes["default"].object
};
exports.appPropTypes = appPropTypes;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.APP_BLOCKED_SET:
      {
        return _objectSpread({}, state, {
          blocked: action.payload
        });
      }

    case _types.APP_BOT_PROJECT_ID_SET:
      {
        return _objectSpread({}, state, {
          botProjectId: action.payload
        });
      }

    case _types.APP_CONTEXT_SET:
      {
        return _objectSpread({}, state, {
          context: action.payload
        });
      }

    case _types.APP_CONVERSATION_ID_SET:
      {
        return _objectSpread({}, state, {
          conversationId: action.payload
        });
      }

    case _types.APP_DEBUG_SET:
      {
        return _objectSpread({}, state, {
          debug: action.payload
        });
      }

    case _types.APP_ENV_SET:
      {
        return _objectSpread({}, state, {
          env: action.payload
        });
      }

    case _types.APP_ERROR_SET:
      {
        return _objectSpread({}, state, {
          error: action.payload
        });
      }

    case _types.APP_INPUT_VALIDATION_SET:
      {
        return _objectSpread({}, state, {
          inputValidation: action.payload
        });
      }

    case _types.APP_PRODUCT_SET:
      {
        return _objectSpread({}, state, {
          product: action.payload
        });
      }

    case _types.APP_SCROLLED_SET:
      {
        return _objectSpread({}, state, {
          scrolled: action.payload
        });
      }

    case _types.APP_SETTINGS_SET:
      {
        return _objectSpread({}, state, {
          settings: action.payload
        });
      }

    case _types.APP_TYPING_SET:
      {
        return _objectSpread({}, state, {
          typing: action.payload
        });
      }

    case _types.APP_VARIABLES_SET:
      {
        return _objectSpread({}, state, {
          variables: _objectSpread({}, state.variables, {}, action.payload)
        });
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;